// extracted by mini-css-extract-plugin
export var serviceSubcategoriesTile = "ServicesSubcategories-module--service-subcategories-tile--e927d";
export var servicesSubcategories = "ServicesSubcategories-module--services-subcategories--92cef";